/* global jQuery */

import { Module } from 'wrapper6'

export default class TabsVariationsHandler extends Module {
  ready () {

    const productDiv = jQuery('.product-type-variable .mtt-single-product__cover')
    if (productDiv.length === 0) {
      return
    }

    const tabsWidgets = jQuery('section.mtt-tabs-widget')
    if (tabsWidgets.length < 2) {
      return
    }

    jQuery(productDiv).on('click', 'section.mtt-variations label', this.handleVariationClick.bind(this))
  }

  handleVariationClick (e) {
    const element = jQuery(e.currentTarget).find('input')
    const tabsWidget = jQuery('section.mtt-tabs-widget[data-variation_type="' + element.val() + '"]')

    if (tabsWidget.length === 0) {
      return
    }

    jQuery('section.mtt-tabs-widget').each((index, section) => {
      jQuery(section).hide()
    })

    tabsWidget.show()
  }

}
